import React, { useEffect, useState, useContext } from "react";
import { MyContext } from "../../../MyContext";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import Loading from "../../pages/Loading";
import { useSession } from "../../session/Context";
import API from "../../Api";
import { useSearchParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";

let serverUrl = window.location.origin;

export default function IssuanceDetails() {
    const { brand } = useSession();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const [loading, setLoading] = useState(true);

    const id = params.get("id");
    const [credentialDetails, setCredentialDetails] = useState<any>({});

    // Get credential types
    useEffect(() => {
        API("/api/v1/brand" + (brand == "" ? "/root" : "/" + brand) + "/offer?id=" + id + "&type=create_urls", {
            method: "GET",
        })
            .then((response) => {
                console.log(response);
                setCredentialDetails(response);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                toast.error("Error creating credential " + error, { theme: "colored" });
            });

    }, []);

    const { onPage, setOnPage } = useContext(MyContext)!;
    useEffect(() => {
        setOnPage("/create_credential");
    }, []);

    const copyLink = () => {

        // Get the text field
        var copyText = credentialDetails.url;

        if (copyText !== undefined) {
            navigator.clipboard.writeText(copyText);
            toast.success("Link copied to clipboard.", {
                theme: "colored",
            });
        }

    }
    return (
        <>
            <div className="mobile-pro">
                <div className="login">
                    <img src="img/issue-icon-default.svg" />
                    <h2>Issuance details</h2>
                </div>
            </div>

            <div className="col-content">
                <div className="notifications-container">
                    <div className="messages m-hide">
                        <p className="light"></p>
                        <h2>Issuance details</h2>
                    </div>

                    <div className="messages  no-mobile-pro"></div>
                    {loading && <Loading />}
                    {!loading && (
                        <div className="cards ">
                            <div className="qr_code_wallet">
                                <div style={{ textAlign: "center" }}>
                                    <QRCodeSVG value={credentialDetails.qr} height="200" width="200" />
                                </div>
                                <div className="divider">OR</div>
                            </div>

                            <p style={{wordBreak:"break-all"}}>{credentialDetails.issuance_link}</p>
                            {/*<input className="template-field" name="types" type="text" value={credentialDetails.url} style={{ fontFamily: "Saira", fontSize: "15px" }} ></input>*/}
                            <br></br>
                            <button className="form-submit-btn btn btn-primary" type="button" value="Copy link"
                                onClick={() => {
                                    copyLink();
                                }}
                            >
                                Copy link
                            </button>

                        </div>
                    )}
                </div>
            </div>


        </>
    );
}
